export const LOGOS_IDS = {
  smsLogo: 'smsLogo',
  hdScanLogo: 'hdScanLogo',
  clientLogo: 'clientLogo',
} as const;
